/**
 * Высота полосы миниатюр поверх превью от нижнего края (CSS px):
 * отступ `bottom-3` (12) + миниатюра `size-11` (44, compact) или `size-16` (64).
 */
export function overlayThumbStripInset(compact: boolean): number {
  return 12 + (compact ? 44 : 64)
}
